export default __webpack_public_path__ + "static/media/bxl-c-plus-plus.bd5578af.svg";